export default {
    indexOccurrenceSheetItems:  { method: 'get',    url: 'occurrence_sheet_items'},
    storeOccurrenceSheetItem:   { method: 'post',   url: 'occurrence_sheet_items' },
    updateOccurrenceSheetItem:  { method: 'put',    url: 'occurrence_sheet_items/{id}'},
    destroyOccurrenceSheetItem: { method: 'delete', url: 'occurrence_sheet_items/{id}'},
    storeRegisterSheetItem:     { method: 'put',    url: 'occurrence_sheet_items/{id}/store_register'},
    absenceRegisterSheetItem:   { method: 'put',    url: 'occurrence_sheet_items/{id}/absence'},
}